<script lang="ts" setup>
import { Badge } from '@vue-interface/badge';
import type { Component, FunctionalComponent } from 'vue';

withDefaults(defineProps<{
    badges?: string[],
    description?: string,
    icon?: Component | FunctionalComponent | string,
    title?: string,
    size?: 'sm' | 'md' | 'lg'
}>(), {
    size: 'md'
});
</script>

<template>
    <div
        :class="{
            'mb-4': !!title
        }"
        class="flex items-center justify-between gap-2">
        <div
            class="flex items-center"
            :class="{
                'gap-1': size === 'sm',
                'gap-2': size === 'md',
                'gap-3': size === 'lg'
            }">
            <slot name="icon">
                <Component
                    :is="icon"
                    v-if="icon"
                    :class="{
                        'h-8 w-8': size === 'sm',
                        'h-10 w-10': size === 'md',
                        'h-12 w-12': size === 'lg'
                    }"
                    class="shrink-0" />
            </slot>
            <div>
                <h1
                    :class="{
                        'text-xl': size === 'sm',
                        'text-2xl': size === 'md',
                        'text-3xl': size === 'lg'
                    }"
                    class="flex items-center break-all font-semibold">
                    <slot name="title">
                        {{ title }}
                    </slot>
                </h1>
                <h3
                    :class="{
                        'text-sm': size === 'sm',
                        'text-base': size === 'md',
                        'text-lg': size === 'lg'
                    }"
                    class="flex items-center break-all text-neutral-400 dark:text-neutral-500">
                    <slot name="description">
                        {{ description }}
                    </slot>
                </h3>
                <div
                    v-if="badges || $slots.badges"
                    class="mt-1 flex flex-wrap items-center gap-1.5">
                    <slot name="badges">
                        <template v-for="badge in badges">
                            <Badge
                                v-if="badge"
                                :key="badge"
                                class="badge-rose-500"
                                size="badge-xs">
                                {{ badge }}
                            </Badge>
                        </template>
                    </slot>
                </div>
            </div>
        </div>

        <div>
            <slot name="actions" />
        </div>
    </div>
</template>